import { Controller } from "stimulus"
import consumer from "channels/consumer"

export default class extends Controller {
  static targets = []

  connect(){
    this.subscription = consumer.subscriptions.create({ channel: "TemplateStatusChannel", id: this.data.get("id")}, {
      connected: this._connected.bind(this),
      disconnected: this._disconnected.bind(this),
      received: this._received.bind(this)
    })
  }

  disconnect(){
    consumer.subscriptions.remove(this.subscription)
  }

  _connected(){

  }

  _disconnected(){

  }

  _received(data){
    console.log(data)
    if (data.status === "content_pending") {
      $("#admin-generating-modal").modal('show')
    } else if (data.status === "content_ready") {
      location.href = this.data.get("path");
    } else if (data.status === "content_failed") {
      alert("Something went wrong generating the content.")
    }
  }

}
